const MY_ADMIN_AUTHENTICATION_TYPE = "MyAdmin";

/**
 * Checks is it a MyAdmin user
 */
export function isMyAdminUser(user: { userAuthenticationType?: string; isAutoAdded?: boolean }): boolean {
    return (user.hasOwnProperty("userAuthenticationType") && user.userAuthenticationType === MY_ADMIN_AUTHENTICATION_TYPE) || (user.hasOwnProperty("isAutoAdded") && user.isAutoAdded === true);
}
